export default __webpack_public_path__ + "static/large-2-e401efd697ab974bdba311eba6311704.jpg";